<template>
  <div class="public_bg">
    <div class="nurse_top">
      <div style="height:54px;line-height:54px;">
        <img style="vertical-align:middle;" src="@/assets/beadhouse/juxing.png">
          <span>楼栋房间床位管理</span>
      </div>
    </div>
    <div class="row_link clearfix">
      <div class="item" v-for='(item,index) in infoList' :key="index" @click="handleClick(item.uid)">
        <a>
          <img :src="item.img">
          <h5 style="font-size:16px;">{{item.title}}</h5>
          <span>{{item.text}}</span>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import bus from "@/vuex/eventBus"; //引入eventBus,接收子界面传递的跳转指令,然后在父界面跳转,添加tab
export default {
  name:"setManagement",  
  data(){
    return {
      infoList:[],//数据源
    }
  },
  methods:{
    //点击每个
    handleClick(uid){
      console.log(uid);
      switch(uid){
        case 1:
          bus.$emit('homePage',{type:'jump',path:'/BuildView',title:"楼栋管理"});
          break;
        case 2:
          bus.$emit('homePage',{type:'jump',path:'/RoomSetting',title:"房间管理"});
          break;
        case 3:
          bus.$emit('homePage',{type:'jump',path:'/BedSetting',title:"床位管理"});
          break;
        case 4:
          bus.$emit('homePage',{type:'jump',path:'/RoomView',title:"床位视图"});
          break;
        case 5:
          bus.$emit('homePage',{type:'jump',path:'/BedRearrangement',title:"床位重排"});
          break; 
      }
    },

    /**
     * 获取菜单栏的数据列表
    */
    getPageData() {
      this.infoList = [];
      this.infoList.push({
        url:'/BuildView',
        img:require("../../../assets/beadhouse/BuildSetting.png"),
        title:'楼栋管理',
        text:'管理机构的楼栋，编辑楼栋信息',
        uid:1
      });
      this.infoList.push({
        url:'/RoomTwoView',
        img:require("../../../assets/beadhouse/RoomSetting.png"),
        title:'房间管理',
        text:'管理机构的房间，编辑房间信息',
        uid:2
      });
      this.infoList.push({
        url:'/BedView',
        img:require("../../../assets/beadhouse/RoomBedSetting.png"),
        title:'床位管理',
        text:'管理机构的床位，编辑床位信息',
        uid:3
      });
      this.infoList.push({
        url:'/RoomView',
        img:require("../../../assets/beadhouse/RoomView.png"),
        title:'床位视图',
        text:'查看机构的床位视图信息',
        uid:4
      });
      this.infoList.push({
        url:'/BedRearrangement',
        img:require("../../../assets/beadhouse/BedRearrangement.png"),
        title:'床位重排',
        text:'给机构的床位重新排序',
        uid:5
      });
    }
  },
  created(){
    this.getPageData(); 
  },
  mounted(){
        
  },
}
</script>
<style lang="scss" scoped>
  .public_bg {
    width: 100%;
    padding:0px 0 20px 0;
    height: 95%;
    background: #FEFEFE;
    .nurse_top {
      border: 1px #F1EFF2 solid;
      background: #F9F7FA;
      position: relative;
        img {
          margin: 14px 12px;
        }
        h5 {
          display: inline-block;
          position: absolute;
          top: 12px;
          font-size: 18px;
        }
    }
    .row_link{
      width: 1259px;
      margin: 34px 35px;
      .item {
        width: 275px;
        height: 99px;
        border: #F0F0F2 1px solid;
        margin-bottom: 34px;
        margin-right: 34px;
        float: left;
        cursor: pointer;
        img {
          float: left;
          margin: 8px 23px 8px 33px;
          margin-right: 16px;
        }
        span {
          color: #666666;
        }
        h5 {
          margin-top: 21px;
          margin-bottom: 8px;
        }
        a:hover {
          color: #333; 
        }
      }
      .item:hover{
        border:1px solid red;
      }
    }
  }
</style>
